var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128008(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-128-008-1,.cls-128-008-3,.cls-128-008-4{fill:#fff;}.cls-128-008-2,.cls-128-008-5{fill:none;}.cls-128-008-2,.cls-128-008-3,.cls-128-008-4{stroke:#6e6e6e;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}.cls-128-008-4{fill-rule:evenodd;}.cls-128-008-5{opacity:0.2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-008-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-008-2",
    points: "92.68 20.58 101.87 19.83 100.37 27.99"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-008-2",
    x1: 21.65,
    y1: 82.31,
    x2: 41.37,
    y2: 54.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-008-2",
    x1: 89.51,
    y1: 30.06,
    x2: 101.43,
    y2: 20.41
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-008-2",
    points: "41.37 54.1 61.1 65.11 69.54 52.65"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128-008-3",
    cx: 41.37,
    cy: 54.1,
    r: 3.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128-008-3",
    cx: 61.1,
    cy: 65.11,
    r: 3.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128-008-3",
    cx: 21.65,
    cy: 82.31,
    r: 3.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-008-4",
    d: "M73.7,91.52V104c0,2.16,3.19,3.91,7.12,3.91s7.12-1.75,7.12-3.91V91.52Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-128-008-3",
    cx: 80.82,
    cy: 91.52,
    rx: 7.12,
    ry: 3.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-008-4",
    d: "M87.94,95.92c0,1.78-3.19,3.23-7.12,3.23S73.7,97.7,73.7,95.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-008-4",
    d: "M87.94,100.32c0,1.79-3.19,3.24-7.12,3.24s-7.12-1.45-7.12-3.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-008-4",
    d: "M14.53,100.67v3.59c0,2.16,3.19,3.91,7.12,3.91s7.12-1.75,7.12-3.91v-3.59Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-128-008-3",
    cx: 21.65,
    cy: 100.59,
    rx: 7.12,
    ry: 3.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-008-4",
    d: "M34,91.52V104c0,2.16,3.19,3.91,7.12,3.91s7.12-1.75,7.12-3.91V91.52Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-128-008-3",
    cx: 41.14,
    cy: 91.52,
    rx: 7.12,
    ry: 3.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-008-4",
    d: "M48.26,95.92c0,1.78-3.19,3.23-7.12,3.23S34,97.7,34,95.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-008-4",
    d: "M48.26,100.32c0,1.79-3.19,3.24-7.12,3.24S34,102.11,34,100.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-008-4",
    d: "M54,96.18v8.08c0,2.16,3.19,3.91,7.13,3.91s7.12-1.75,7.12-3.91V96.18Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-128-008-3",
    cx: 61.1,
    cy: 96.18,
    rx: 7.12,
    ry: 3.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-008-4",
    d: "M68.22,96.18c0,1.79-3.19,3.23-7.12,3.23S54,98,54,96.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-008-4",
    d: "M68.22,100.59c0,1.78-3.19,3.23-7.12,3.23S54,102.37,54,100.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-008-4",
    d: "M94.31,87.55v16.71c0,2.16,3.19,3.91,7.12,3.91s7.12-1.75,7.12-3.91V87.55Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-128-008-3",
    cx: 101.43,
    cy: 87.32,
    rx: 7.12,
    ry: 3.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-008-4",
    d: "M108.55,91.78c0,1.78-3.19,3.23-7.12,3.23s-7.12-1.45-7.12-3.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-008-4",
    d: "M108.55,96.18c0,1.79-3.19,3.23-7.12,3.23S94.31,98,94.31,96.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-008-4",
    d: "M108.55,100.59c0,1.78-3.19,3.23-7.12,3.23s-7.12-1.45-7.12-3.23"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128-008-2",
    cx: 77.6,
    cy: 39.7,
    r: 15.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-008-2",
    d: "M76.45,50.69a10.8,10.8,0,0,1-6.71-5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-008-2",
    d: "M68,42.08a9.8,9.8,0,0,1-.44-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-008-2",
    d: "M93.66,52.26,112.59,71.2a3,3,0,0,1,0,4.26h0a3,3,0,0,1-4.26,0L89.39,56.52Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-008-2",
    x1: 88.04,
    y1: 50.91,
    x2: 91.52,
    y2: 54.39
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128008);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_008.fb82000163f0276d86a8ee666e9cc953.svg";
export { ForwardRef as ReactComponent };